var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PaymentVisa",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-visa","viewBox":"0 0 500 312"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="500" height="312" fill="#F8F8F8" className="dibsvg-color-holder"/>
  <g fill="#0066B2" className="dibsvg-color-letters" transform="translate(53 93)">
    <path d="M389.786 113.812c0-3.125 3.125-6.25 6.25-6.25s6.25 3.125 6.25 6.25-3.125 6.25-6.25 6.25-6.25-3.125-6.25-6.25zm6.25 4.167c3.125 0 5.209-2.084 5.209-5.209 0-3.125-2.084-5.208-5.209-5.208-3.125 0-5.208 2.083-5.208 5.208s2.083 5.209 5.208 5.209zm-1.041-2.084h-1.042v-5.208h3.125l1.042 1.042c0 1.041 0 1.041-1.042 1.041l1.042 2.084h-1.042l-1.042-1.042h-1.041v2.083zm0-3.125h1.041v-2.083h-1.041v2.083z"/>
    <path d="M357.458 120.625h29.167l-25-118.75h-25c-11.458 0-14.583 8.333-14.583 8.333l-46.875 109.375H308.5l6.25-17.708h39.583l3.125 18.75zm-34.375-41.667l16.667-43.75 9.375 43.75h-26.042zM277.25 31.042l4.167-25S267.875.833 253.292.833c-15.625 0-53.125 6.25-53.125 38.542 0 30.208 43.75 31.25 43.75 46.875s-39.584 13.542-52.084 3.125l-4.166 26.042s13.541 6.25 35.416 6.25c21.875 0 54.167-10.417 54.167-40.625 0-30.209-43.75-33.334-43.75-46.875-1.042-12.5 30.208-10.417 43.75-3.125"/>
    <path d="M65.792 13.333l10.416 53.125-10.416-53.125S64.75 2.917 51.208 2.917h-25l35.417 25 14.583 38.541 3.125 17.709 30.209-81.25h34.375l-50 117.708H60.583L33.5 18.542C15.792 8.125.167 5 .167 5l1.041-2.083h25"/>
    <polyline points="167.875 120.625 136.625 120.625 155.375 1.875 187.667 1.875 167.875 120.625"/>
  </g>
  <path fill="#F9A533" d="M129.208 159.458l-10.416-53.125s-1.042-10.416-14.584-10.416h-50l-1.041 1.041s23.958 5.209 46.875 22.917c21.875 17.708 29.166 39.583 29.166 39.583" className="dibsvg-color-letters-top"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/payment-visa.svg